import {BotData} from '../../../../../api/types';
import {UserInfo} from '../../../../../api/usersApi/usersApi.types';
import {Message} from '../../../../../common-lib/src/api/Api';

export const prepareObjForAnalitics = (
	bot: BotData,
	user?: UserInfo | null,
	message?: Message
) => {
	return {
		bot_name: bot.attributes.name,
		chat_id: bot.id,
		chat_type: 'default' as 'default' | 'custom_shared' | 'custom',
		access_level: user?.accessLevel || 'basic',
		split_response: message?.split,
	};
};

export const highlightText = (text: string, search: string) => {
	if (!search) return text;

	const parts = text.split(new RegExp(`(${search})`, 'gi'));
	return parts
		.map((part, i) =>
			part.toLowerCase() === search.toLowerCase()
				? `<span class="highlight">${part}</span>`
				: part
		)
		.join('');
};
